import {
  UPDATE_MANAGER_EMPLOYEE_REQUEST,
  UPDATE_MANAGER_EMPLOYEE_SUCCESS,
  UPDATE_MANAGER_EMPLOYEE_FAILURE,
  ADD_MANAGER_EMPLOYEE_REQUEST,
  ADD_MANAGER_EMPLOYEE_SUCCESS,
  ADD_MANAGER_EMPLOYEE_FAILURE,
  DELETE_MANAGER_EMPLOYEE_REQUEST,
  DELETE_MANAGER_EMPLOYEE_SUCCESS,
  DELETE_MANAGER_EMPLOYEE_FAILURE
} from "../../Constants";

import { managerTimesheet } from "../../Api/managerTimesheet";

function requestUpdateEmployee() {
  return {
    type: UPDATE_MANAGER_EMPLOYEE_REQUEST,
    isFetching: true
  };
}

function updateEmployeeSuccess(data) {
  return {
    type: UPDATE_MANAGER_EMPLOYEE_SUCCESS,
    isFetching: false,
    data
  };
}

function updateEmployeeError(errorMessage) {
  return {
    type: UPDATE_MANAGER_EMPLOYEE_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestaddEmployee() {
  return {
    type: ADD_MANAGER_EMPLOYEE_REQUEST,
    isFetching: true
  };
}

function addEmployeeSuccess(data) {
  return {
    type: ADD_MANAGER_EMPLOYEE_SUCCESS,
    isFetching: false,
    data
  };
}

function addEmployeeError(errorMessage) {
  return {
    type: ADD_MANAGER_EMPLOYEE_FAILURE,
    isFetching: false,
    errorMessage
  };
}

function requestDeleteEmployee() {
  return {
    type: DELETE_MANAGER_EMPLOYEE_REQUEST,
    isFetching: true
  };
}

function deleteEmployeeSuccess(data) {
  return {
    type: DELETE_MANAGER_EMPLOYEE_SUCCESS,
    isFetching: false,
    data
  };
}

function deleteEmployeeError(errorMessage) {
  return {
    type: DELETE_MANAGER_EMPLOYEE_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const updateManagerEmployee = payload => (dispatch, getState) => {
  dispatch(requestUpdateEmployee());
  managerTimesheet
    .updateEmployeeManager(payload)
    .then(res => {
      dispatch(updateEmployeeSuccess(res));
    })
    .catch(err => dispatch(updateEmployeeError(err)));
};

export const addManagerEmployee = payload => (dispatch, getState) => {
  dispatch(requestaddEmployee());
  managerTimesheet
    .addEmployeeManager(payload)
    .then(res => {
      dispatch(addEmployeeSuccess(res));
    })
    .catch(err => dispatch(addEmployeeError(err)));
};

export const deleteManagerEmployee = payload => (dispatch, getState) => {
  dispatch(requestDeleteEmployee());
  managerTimesheet
    .deleteEmployeeManager(payload)
    .then(res => {
      dispatch(deleteEmployeeSuccess(res));
    })
    .catch(err => dispatch(deleteEmployeeError(err)));
};

export const resetEmployeeMessage = payload => (dispatch, getState) => {
  dispatch(addEmployeeSuccess(""));
};
